import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';
import { REPORT_OWN_PERMISSIONS, REPORT_SUMMARY_PERMISSIONS, REPORT_TEAM_PERMISSIONS } from './nav.js';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function guarded(load: () => Promise<PageModule>, anyOf: string[]): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    const Page = m.default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
}

/**
 *   /report                    今日の日報（REPORT-01）
 *   /report/days/:reportOn     指定日の自分の日報（履歴から開く。下書きなら書ける）
 *   /report/history            履歴（REPORT-02: 日付の一覧）
 *   /report/team               部下の日報（上長）/ 書く人全員の状況（管理者）
 *   /report/reports/:id        1 本の閲覧（上長・管理者。本人の下書きなら編集画面へ誘導）
 *   /report/summary            期間集計（週報は作らない・03 §19.5）
 */
export const reportRoutes: RouteObject[] = [
  { path: '/report', lazy: guarded(() => import('./pages/TodayReportPage.js'), REPORT_OWN_PERMISSIONS) },
  { path: '/report/days/:reportOn', lazy: guarded(() => import('./pages/TodayReportPage.js'), REPORT_OWN_PERMISSIONS) },
  { path: '/report/history', lazy: guarded(() => import('./pages/ReportHistoryPage.js'), REPORT_OWN_PERMISSIONS) },
  { path: '/report/team', lazy: guarded(() => import('./pages/TeamReportsPage.js'), REPORT_TEAM_PERMISSIONS) },
  { path: '/report/reports/:id', lazy: guarded(() => import('./pages/ReportDetailPage.js'), REPORT_OWN_PERMISSIONS) },
  { path: '/report/summary', lazy: guarded(() => import('./pages/ReportSummaryPage.js'), REPORT_SUMMARY_PERMISSIONS) },
];
